import React from 'react'

import cn from 'classnames'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react'

import classes from './numbers-carousel.module.scss'

type NumbersCarouselProps = {
  quantity: number
  value?: number
  index?: number
  dataTestId?: string
  ariaLabel?: string
  wrapperClassName?: string
  handleSelect: (value: number) => void
} & SwiperProps

export const NumbersCarousel = ({
  quantity,
  value = 0,
  index = 0,
  handleSelect,
  dataTestId = '',
  ariaLabel = 'Numbers carousel',
  wrapperClassName,
  ...props
}: NumbersCarouselProps) => {
  const counterValues: number[] = Array.from(
    { length: quantity },
    (_, i) => i + 1
  )

  return (
    <Swiper
      modules={[Navigation, Pagination]}
      aria-label={ariaLabel}
      className={cn(classes.wrapper, wrapperClassName)}
      allowTouchMove
      initialSlide={index}
      navigation={false}
      onSlideChangeTransitionEnd={(swiper) => {
        const activeSlide = swiper.slides[swiper.activeIndex] as HTMLElement
        activeSlide?.focus()
      }}
      spaceBetween={4}
      slidesPerView="auto"
      data-testid={dataTestId}
      role="region"
      aria-roledescription="carousel"
      {...props}
    >
      {counterValues.map((i) => {
        const isSelected = value === i

        return (
          <SwiperSlide
            key={i}
            data-testid={`swiper-slide-number-${i}`}
            role="group"
            aria-roledescription="slide"
          >
            <button
              type="button"
              className={
                isSelected
                  ? cn(classes.number, classes.selected)
                  : classes.number
              }
              data-testid={`number-of-members-${i}`}
              onClick={() => handleSelect(i)}
              aria-pressed={isSelected}
              aria-label={`Select ${i}`}
              tabIndex={0}
            >
              {i}
            </button>
          </SwiperSlide>
        )
      })}
    </Swiper>
  )
}
